import { render, staticRenderFns } from "./wine.vue?vue&type=template&id=8398af96&scoped=true&"
import script from "./wine.vue?vue&type=script&lang=js&"
export * from "./wine.vue?vue&type=script&lang=js&"
import style0 from "./wine.vue?vue&type=style&index=0&id=8398af96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8398af96",
  null
  
)

export default component.exports